var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"various_graphics",attrs:{"id":_vm.id_type}})
}
var staticRenderFns = []

export { render, staticRenderFns }